import { useTranslation } from "react-i18next";
import {
  localizedInputPropsFromLanguage,
  type LocalizedInputProps,
} from "../utils/documentLanguage";

/**
 * Returns `lang` + `dir` for inputs/textareas so they match the app language.
 * Prefer relying on global `<html lang>` + CSS; use this inside subtrees that
 * force `direction: ltr` (e.g. mixed-order layouts).
 */
export function useLocalizedInputProps(): LocalizedInputProps {
  const { i18n } = useTranslation();
  const lng = i18n.resolvedLanguage || i18n.language;
  return localizedInputPropsFromLanguage(lng);
}
